module.exports = __webpack_public_path__ + "img/112.e1a989a1.webp";